<template>
  <div>
    <div class="sendLinkToCoursesBot-nav mt-20">
      <app-btn
          title="Показать курсы"
          :class="{'active': currentTabComponent === 'course-layout'}"
          @onClick="currentTabComponent='course-layout'"
      />

      <app-btn
          title="Добавить курс"
          :class="{'active': currentTabComponent === 'add-course-layout'}"
          @onClick="currentTabComponent='add-course-layout'"
      />
    </div>

      <keep-alive>
        <component
            :is="importedTabComponent"
            :botName="botName"
        ></component>
      </keep-alive>
  </div>
</template>

<script>
import ContentTable from "@/components/ContentTable.vue";
import AppBtn from "@/components/AppBtn.vue";

const CourseLayout = () => import("../layouts/CourseLayout.vue");
const AddCourseLayout = () => import("../layouts/AddCourseLayout.vue");

export default {
  name: "SendLinkToCoursesBot",
  components: {AppBtn, ContentTable},
  props: {
    botName: {
      type: String
    }
  },
  data: () => ({
    isLoading: false,
    isError: false,
    currentTabComponent: 'course-layout',
  }),
  computed: {
    importedTabComponent() {
      if (this.currentTabComponent === 'course-layout') {
        return CourseLayout
      } else {
        return AddCourseLayout
      }
    }
  }
}
</script>

<style scoped>
.sendLinkToCoursesBot-nav {
  display: flex;
  gap: 20px;
}
.active {
  background: #859ae8;
}
</style>